
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 75 18","preserveAspectRatio":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8d1b3d","d":"M0 0h75v18H0z"}}),_c('path',{attrs:{"d":"M22 18H0V0h22l6 1-6 1 6 1-6 1 6 1-6 1 6 1-6 1 6 1-6 1 6 1-6 1 6 1-6 1 6 1-6 1 6 1z","fill":"#fff"}})])
          )
        }
      }
    